<template>
  <!--
    Reusable money/price input. Displays the value with thousand separators
    (e.g. 8 000 000) while keeping the bound v-model a raw integer (so'm).
    Reuses formatterPrice/parserPrice so price formatting is not duplicated.
    All extra attributes (size, placeholder, disabled, ...) pass through.
  -->
  <el-input
    :model-value="rawValue"
    :formatter="formatterPrice"
    :parser="parserPrice"
    inputmode="numeric"
    v-bind="$attrs"
    @update:model-value="onUpdate"
  />
</template>

<script>
import { formatterPrice, parserPrice } from "@/utils/common";

export default {
  name: "MfPriceInput",
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    rawValue() {
      if (this.modelValue === null || this.modelValue === undefined || this.modelValue === "") {
        return "";
      }
      return String(this.modelValue);
    },
  },
  methods: {
    formatterPrice,
    parserPrice,
    onUpdate(value) {
      const raw = parserPrice(value);
      const next = raw === "" ? null : Number(raw);
      // el-input (with formatter/parser) emits once on init; skip when the
      // value hasn't really changed so we don't trigger premature validation.
      if (next === this.modelValue) return;
      this.$emit("update:modelValue", next);
    },
  },
};
</script>
